import React from 'react';
import ReactLoading from "react-loading";

function LoadingStatus({ size }) {
  return (
    <div className='loading_status'> <ReactLoading type="spinningBubbles" color="#56148a"
                    height={size} width={size} /></div>
  );
}

export default LoadingStatus;